export const teamProjects = [
  {
    id: 1,
    title: "Store",
    subtitle: "Responsive application build with bootsrap",
    description: "The project was created with Bootstrap",
    image: "images/teamproject1.webp",
    fullDesc:
      "Fully responsive page using Bootstrap.On click on each card modal with the card details is displayed.Font-awesome icons were used as well.",
    isFlipped: false,
  },
  {
    id: 2,
    title: "Pagination",
    subtitle: "Responsive application build with jQuery",
    description: "The project was created with jQuery",
    image: "images/teamproject2.webp",
    fullDesc:
      "We created a responsive page using pagination to display the items. We extened the project and added a select bar to choose how many items we would like to be displayed per page.",
    isFlipped: false,
  },
  {
    id: 3,
    title: "Zoo",
    subtitle: "Responsive application build with Javascript",
    description: "The project was created with Javascript",
    image: "images/teamproject3.webp",
    fullDesc:
      "We created a responsive page with functionality of the buttons that are filtering the animal cards based on their age.On click on the 'Add animal' button a modal with a form is displayed.The form could only be submitted if all the input fields are filled.",
    isFlipped: false,
  },
  {
    id: 4,
    title: "Kerri",
    subtitle: "Responsive application build with Bootstrap",
    description: "The project was created with Bootstrap",
    image: "images/teamproject4.webp",
    fullDesc:
      "For this project we created a responsive page using Bootstrap. Scroll to top button was created, filter was used for the background image and while hovering the cards,their details were displayed.",
    isFlipped: false,
  },
  {
    id: 5,
    title: "Artistic",
    subtitle: "Responsive page build with jQuery",
    description: "The project was created with jQuery",
    image: "images/teamproject5.webp",
    fullDesc:
      "We created a listing-page design approach using jQuery to load content continuously as the user scrolls down.",
    isFlipped: false,
  },
  {
    id: 6,
    title: "Boxes",
    subtitle: "Responsive page build with CSS using Flex",
    description: "The project was created with CSS using Flex",
    image: "images/teamproject6.webp",
    fullDesc:
      "Responsive page with menu bar on the left side fixed on large screens. When the page is opened on tablet on a mobile device the menu is hidden and hamburger button is present.",
    isFlipped: false,
  },
  {
    id: 7,
    title: "Store",
    subtitle: "Responsive page build with Bootstrap",
    description: "The project was created with Bootstrap",
    image: "images/teamproject7.webp",
    fullDesc:
      "For this project we created a responsive page using Bootstrap. Detail page with the information about the image is displayed when image is clicked.",
    isFlipped: false,
  },
  {
    id: 8,
    title: "Business Solutions",
    subtitle: "Responsive page build with SCSS",
    description: "The project was created with SCSS",
    image: "images/teamproject8.webp",
    fullDesc:
      "For this project we created a responsive page using SCSS with variables & common element styles. The background have a parallax effect, except on mobile resolution where be scrollable.",
    isFlipped: false,
  },
];
